import React from 'react'
import { Modal } from 'react-bootstrap'
// import ModalHapusError from './modalHapusError'

export default class modalHapus extends React.Component {

    render() {
        const { saveHandler, Model, ShowModalDel, ShowModalDelErr, cancelHandler, errors } = this.props

        return (

            <div class="mb-10">

                <Modal show={ShowModalDel} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Hapus</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p class="margintext">Anda setuju untuk menghapus</p>
                            <p class="margintext">{Model.name} ?</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={saveHandler} >Yakin</button>
                        {/* <button class="btn btn-danger" href='./modalHapusError' >Yakin</button> */}
                        {/* <button class="btn btn-danger" onClick={saveHandler} window.location.href = ('/modalHapusError') >Yakin</button> */}
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
